module.exports = __webpack_public_path__ + "img/tx.81a8cd9e.png";